import { UsersFormData } from '@/types/usersFormData'

export const initialUserFormData: UsersFormData = {
  id: 0,
  loginId: '',
  name: '',
  password: '',
  role: 0,
}
